import _regenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import * as signalR from '@microsoft/signalr';
import { getToken } from '@/utils/auth';
var CustomerServiceSignalR = /*#__PURE__*/function () {
  function CustomerServiceSignalR() {
    _classCallCheck(this, CustomerServiceSignalR);
    this.connection = null;
    this.isConnected = false;
    this.agentId = null;
  }
  return _createClass(CustomerServiceSignalR, [{
    key: "createConnection",
    value: function createConnection() {
      return new signalR.HubConnectionBuilder().withUrl('api/v5/hubs/customer-service', {
        accessTokenFactory: function accessTokenFactory() {
          return getToken() || '';
        },
        transport: signalR.HttpTransportType.WebSockets | signalR.HttpTransportType.ServerSentEvents | signalR.HttpTransportType.LongPolling,
        skipNegotiation: false
      }).withAutomaticReconnect().build();
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(agentId) {
        var _this = this;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (agentId) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              if (!(this.connection && this.agentId === agentId)) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              _context2.n = 3;
              return this.stop();
            case 3:
              this.agentId = agentId;
              this.connection = this.createConnection();
              this.connection.onreconnected(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      _this.isConnected = true;
                      _context.n = 1;
                      return _this.joinAgentWorkspace();
                    case 1:
                      return _context.a(2);
                  }
                }, _callee);
              })));
              this.connection.onclose(function () {
                _this.isConnected = false;
              });
              _context2.n = 4;
              return this.connection.start();
            case 4:
              this.isConnected = true;
              _context2.n = 5;
              return this.joinAgentWorkspace();
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function init(_x) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "joinAgentWorkspace",
    value: function () {
      var _joinAgentWorkspace = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(this.connection && this.isConnected && this.agentId)) {
                _context3.n = 1;
                break;
              }
              _context3.n = 1;
              return this.connection.invoke('JoinAgentWorkspace', this.agentId);
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function joinAgentWorkspace() {
        return _joinAgentWorkspace.apply(this, arguments);
      }
      return joinAgentWorkspace;
    }()
  }, {
    key: "on",
    value: function on(eventName, callback) {
      if (this.connection) {
        this.connection.on(eventName, callback);
      }
    }
  }, {
    key: "off",
    value: function off(eventName, callback) {
      if (this.connection) {
        this.connection.off(eventName, callback);
      }
    }
  }, {
    key: "invoke",
    value: function () {
      var _invoke = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(methodName) {
        var _this$connection;
        var _len,
          args,
          _key,
          _args4 = arguments;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!(!this.connection || !this.isConnected)) {
                _context4.n = 1;
                break;
              }
              throw new Error('客服连接未建立');
            case 1:
              for (_len = _args4.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = _args4[_key];
              }
              _context4.n = 2;
              return (_this$connection = this.connection).invoke.apply(_this$connection, [methodName].concat(args));
            case 2:
              return _context4.a(2, _context4.v);
          }
        }, _callee4, this);
      }));
      function invoke(_x2) {
        return _invoke.apply(this, arguments);
      }
      return invoke;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _t;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (!this.connection) {
                _context5.n = 4;
                break;
              }
              _context5.p = 1;
              _context5.n = 2;
              return this.connection.stop();
            case 2:
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t = _context5.v;
              console.warn('[CustomerServiceSignalR] stop failed:', _t);
            case 4:
              this.connection = null;
              this.isConnected = false;
              this.agentId = null;
            case 5:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3]]);
      }));
      function stop() {
        return _stop.apply(this, arguments);
      }
      return stop;
    }()
  }]);
}();
export default new CustomerServiceSignalR();